import $ from 'jquery'; // eslint-disable-line import/no-extraneous-dependencies
import bootstrapSite from '../app/bootstrapSite';
import createObserver from '../utilities/createObserver';
import api from '../common/services/api';

import { createCarousel } from '../common/components/carousels';
import attachTopBanner from '../common/helpers/handleUserAreaClick/attachTopBanner';

bootstrapSite();

// For IE10 show first image
// of carousel only

if (document.documentMode === 10) {
    $('.carousel > article').first().css('opacity', '1');
    $('.carousel > article div > img').first().css('top', '-75%');
}

const SENTENCES_ON_ROTATION = [
    'Curated collections: hotels hand-picked by us',
    'The hottest new hotels and travel inspiration every month',
    'Earn money back every time you stay',
    'Exclusive member-only savings of up to 50%',
    'Smith Extras: a free gift on arrival such as champagne or a massage',
    'Best-price guarantee: we’ll match the price and give you £50',
]

const createSentenceWrapper = (sentence) => {
    const element = document.createElement('div');
    element.classList.add('proposition-sentence');
    element.innerHTML = sentence;
    element.ariaHidden = true;

    return element;
}

function handlePropositionsSentencesOnRotation() {
    const propositionWrapper = document.querySelector('.proposition-sentences');

    if(!propositionWrapper) {
        return;
    }

    let index = 0;

    let currentProposition = createSentenceWrapper(SENTENCES_ON_ROTATION[index]);
    propositionWrapper.appendChild(currentProposition);

    const goToNext = () => {  
        currentProposition.ariaHidden = undefined;
        const nextProposition = createSentenceWrapper(SENTENCES_ON_ROTATION[index + 1] || SENTENCES_ON_ROTATION[0]);
        propositionWrapper.appendChild(nextProposition);

        setTimeout(() => {
            propositionWrapper.addEventListener('transitionend', () => {
                currentProposition.remove();
                currentProposition = nextProposition;
                propositionWrapper.classList.remove('transitioning');
                propositionWrapper.style.setProperty("--translate", '0');
    
                index = index === SENTENCES_ON_ROTATION.length ? 0 : index + 1;
    
                goToNext();
            }, {
                once: true
            });

            if(!propositionWrapper) {
                return;
            }

            propositionWrapper.classList.add('transitioning');
            propositionWrapper.style.setProperty("--translate", '-100%');
        }, 2000)
    }

    goToNext();
}

function handlePropositionsCarousel() {
    createCarousel({
        HTMLWrapper: document.getElementById("mobile-propositions-carousel"),
        cols: {
            xs: 1.8,
            sm: 2.6,
            md: 4,
        }
    })
}

window.addEventListener('load', () => {
    const $parentColl = $('#homepage-collections-list li');
    const $coll = $('#collToggle');
    const sliceNum = 7;

    $coll.slideToggleContent($parentColl, sliceNum, 500, 'swing', { more: 'Show All', less: 'Close' }, () => {
        $(window).trigger('scroll.odimg');
    });

    handlePropositionsSentencesOnRotation();
    handlePropositionsCarousel();

    api.getEditableBanner()
        .then((response) => {
            if (response.status) {
                const {
                    link, linkText, title
                } = response.data;

                attachTopBanner({detail: {
                    actionHref: link,
                    actionText: linkText,
                    closable: true,
                    text: title
                }})
            }
        });
});
